export default function replacePathPrefixHref(pathPrefix) {
  const aTags = document.querySelector('.doc-content').getElementsByTagName('a')
  const prefixOrigin = process.env.PLACEHOLDER_DOC_PREFIX

  if (pathPrefix === prefixOrigin) return

  Array.from(aTags).forEach((a) => {
    const hrefText = a.getAttribute('href')

    if (hrefText.startsWith(prefixOrigin)) {
      a.href = decodeURIComponent(a.getAttribute('href')).replace(prefixOrigin, pathPrefix)
      a.innerHTML = a.innerHTML.replaceAll(prefixOrigin, pathPrefix)
    }
  })

  const codeTags = document.querySelector('.doc-content').getElementsByTagName('code')
  const descriptions = document.querySelectorAll('.doc-content .ant-descriptions-item-content')
  const allApiTags = Array.from(codeTags).concat(Array.from(descriptions))
  allApiTags.forEach(($el) => {
    const innerHTML = $el.innerHTML;
    if (innerHTML.includes(prefixOrigin)){
      $el.innerHTML = innerHTML.replaceAll(prefixOrigin, pathPrefix)
    }
  })
}
